import React, { useState, useEffect } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper-bundle.css'
import { Chip, SwiperContainer } from './swiperStyles'
// import { CHIPS } from './content'
import { handleSwiperTranslate } from './helpers/swiperTranslate'
import { handleResetChipsScale } from './helpers/resetChipsScale'
import ChipSelect from '../../../lib/assets/audio/chipsSelection.mp3'
import useSound from 'use-sound'
import {
  formatMin,
  formatThousand,
  formatThousandWithDecimals,
} from '../helpers/helperChip'
// import { handleSwiperProgress } from './helpers/swiperProgress'

export default function ChipSwiper({
  gameInfo,
  handleChip,
  gameState,
  state,
  audio,
  helperClearBoard,
}: any) {
  const [currentChip, setCurrentChip] = useState<number>(0)
  const [anim, setAnim] = useState<boolean>(false)
  const [clear, setClear] = useState<boolean>(false)
  const [chipSelectSFX] = useSound(ChipSelect, {
    volume: audio?.volume ? parseFloat(audio.volume) : 0,
  })

  const [min, setMin] = useState<number>(0.1)
  const [max, setMax] = useState<number>(100)

  useEffect(() => {
    // Math.round(gameInfo.minBet * 10) / 10
    const minBet = gameInfo.minBet
    const maxBet = gameInfo.maxBet
    setMin(minBet)
    setMax(maxBet)
  }, [gameInfo])

  const formatNumber = (n: number) => {
    let newNum = Math.ceil(n).toString()
    if (+newNum > 999) {
      if (formatThousandWithDecimals(max) === formatThousand(+n)) {
        newNum = formatThousandWithDecimals(n)
      } else newNum = formatThousand(n)
    } else {
      if (+newNum > 100) {
        newNum = (Math.ceil(+newNum / 100) * 100).toString()
      } else newNum = (Math.ceil(+newNum / 10) * 10).toString()
    }
    return newNum
  }

  //  ['100', '0.1', '0.2', '0.5', '1', '5', '10', '25', '50']
  // ['1', '2', '5', '10', '15', '20', '25', '50', '100']

  const CHIPS =
    min <= 1
      ? [
          formatThousandWithDecimals(max),
          formatMin(min),
          '2',
          '5',
          '10',
          '15',
          '20',
          '25',
          '50',
        ]
      : [
          formatThousandWithDecimals(max),
          formatMin(min),
          formatNumber(min + (max - min) / 100),
          formatNumber(min + (2 * (max - min)) / 100),
          formatNumber(min + (3 * (max - min)) / 60),
          formatNumber(min + (4 * (max - min)) / 40),
          formatNumber(min + (5 * (max - min)) / 25),
          formatNumber(min + (6 * (max - min)) / 15),
          formatNumber(min + (7 * (max - min)) / 10),
        ]

  const handleCurrentChip = (c: string) => {
    const number = c
    if ((gameState === 5 || gameState === 6 || gameState === 11) && !clear) {
      helperClearBoard()
      setClear(true)
      handleChip(number)
    } else {
      handleChip(number)
      audio.sound && chipSelectSFX()
      setAnim(true)
      setTimeout(() => {
        setAnim(false)
      }, 167)
    }
  }
  const handleSwipe = (e: any) => {
    handleSwiperTranslate(e)
  }

  useEffect(() => {
    setClear(false)
  }, [gameState])

  return (
    <SwiperContainer state={state}>
      <Swiper
        className='swiper-wrapper'
        slidesPerView={4.75}
        initialSlide={3}
        loop={true}
        centeredSlides={true}
        freeMode={true}
        freeModeSticky={true}
        freeModeMomentumRatio={0}
        freeModeMomentumBounce={true}
        shortSwipes={false}
        longSwipes={false}
        longSwipesRatio={0}
        threshold={10}
        speed={100}
        slideToClickedSlide={true}
        onProgress={e => handleSwipe(e)}
        preventInteractionOnTransition={true}
        onTransitionEnd={e => {
          handleResetChipsScale(e)
          setCurrentChip(e.realIndex)
        }}
      >
        {CHIPS.map((chip, id) => (
          <SwiperSlide
            key={id}
            onClick={() =>
              !state && currentChip === id && handleCurrentChip(chip)
            }
          >
            <Chip anim={anim && currentChip === id}>
              <span>{chip}</span>
            </Chip>
          </SwiperSlide>
        ))}
      </Swiper>
    </SwiperContainer>
  )
}
